import { appFetch } from "./httputil";

export interface ServerFile {
  name: string;
  size: number;
  uploadedAt: number;
}

export async function listServerFiles(): Promise<ServerFile[]> {
  const rsp = await appFetch("/api/files");
  if (!rsp.ok) {
    throw new Error(`failed to list files: ${rsp.status}`);
  }
  const body = (await rsp.json()) as { files?: ServerFile[] };
  return body.files ?? [];
}

export async function uploadServerFile(name: string, data: Uint8Array): Promise<void> {
  const rsp = await appFetch(`/api/files?name=${encodeURIComponent(name)}`, {
    method: "POST",
    body: data as unknown as BodyInit,
  });
  if (!rsp.ok) {
    const body = (await rsp.json().catch(() => ({}))) as { error?: string };
    throw new Error(body.error || `failed to upload: ${rsp.status}`);
  }
}

export async function downloadServerFile(name: string): Promise<Uint8Array> {
  const rsp = await appFetch(`/api/file?name=${encodeURIComponent(name)}`);
  if (!rsp.ok) {
    throw new Error(`failed to download ${name}: ${rsp.status}`);
  }
  return new Uint8Array(await rsp.arrayBuffer());
}

export async function removeServerFile(name: string): Promise<void> {
  const rsp = await appFetch(`/api/file?name=${encodeURIComponent(name)}`, { method: "DELETE" });
  // 404: already removed, e.g. from another browser
  if (!rsp.ok && rsp.status !== 404) {
    const body = (await rsp.json().catch(() => ({}))) as { error?: string };
    throw new Error(body.error || `failed to remove ${name}: ${rsp.status}`);
  }
}
